export default __webpack_public_path__ + "static/media/dedication.5a7c57c0.txt";